export const DEFAULT_TIME_STEP_MINUTES = 1;
